import axios from '../utils/request';

/**
 *
 */

export const _repaymentAgreementInfo = (data: any) => {
  return axios.request({
    url: '/gw/loan/secure/employ-commission',
    method: 'post',
    data
  });
};

export const _fetchJustifyLiquidate = (data: any) => {
  return axios.request({
    url: '/gw/loan/remedy/justify-liquidate',
    method: 'post',
    data
  });
};
